export function attemptTypeToLevel(type)
{
	switch(type)
	{
		case 'L1S1':
		case 'L1S2':
		case 'L1S3':
			return 'Level 1';
		case 'L2S1':
		case 'L2S2':
			return 'Level 2';
		case 'L3S1':
			return 'Level 3';
		case 'RSO':
			return 'RSO';
		case 'MAPA':
			return 'MAP Assessor'
		default:
			return type;
	}
}

export function attemptTypeToFullAttempt(type)
{
	switch(type)
	{
		case 'L1S1':
			return 'Level 1 - Qualifier 1';
		case 'L1S2':
			return 'Level 1 - Qualifier 2';
		case 'L1S3':
			return 'Level 1 - Certification';
		case 'L2S1':
			return 'Level 2 - Qualifier';
		case 'L2S2':
			return 'Level 2 - Certification';
		case 'L3S1':
			return 'Level 3 - Certification';
		default:
			return type;
	}
}

export function certLevelToLevel(level)
{
	switch(level)
	{
		case 'level1':
			return 'Level 1'
		case 'level2':
			return 'Level 2'
		case 'level3':
			return 'Level 3'
		default:
			return 'None';
	}
}

export function rsoLevelToLevel(level)
{
	switch(level)
	{
		case 'model':
			return 'Model'
		case 'level1':
			return 'Level 1'
		case 'level2':
			return 'Level 2'
		case 'level3':
			return 'Level 3'
		default:
			return 'None';
	}
}

export function statusToStatus(status)
{
	switch(status)
	{
		case 'pending':
			return 'Pending UKRA';
		case 'rejected':
			return 'Rejected';
		case 'approved':
			return 'Approved';
	}
	return status;
}

export function insuranceStatus(status)
{
	switch(status)
	{
		case 'active':
			return 'Valid';
		case 'expired':
			return 'Expired';
	}
	return 'Not valid';
}

export function recordTypeToEnglish(type)
{
	switch(type)
	{
		case 'single':
			return 'Single motor';
		case 'cluster':
			return 'Cluster';
		case 'staged':
			return 'Staged';
		case 'handicapped':
			return 'Handicapped'
		default:
			return type;
	}

}

export function motorsToString(motors)
{
	return motors?.map(m => m.name).join(', ')
}

export function impulseToClass(impulse)
{
	if(!impulse)
		return 'N/A';
	if(impulse <= 0.03125)
		return 'Micro';
	if(impulse <= 0.625)
		return '1/4A';
	if(impulse <= 1.25)
		return '1/2A';
	if(impulse <= 2.5)
		return 'A';
	if(impulse <= 5)
		return 'B';
	if(impulse <= 10)
		return 'C';
	if(impulse <= 20)
		return 'D';
	if(impulse <= 40)
		return 'E';
	if(impulse <= 80)
		return 'F';
	if(impulse <= 160)
		return 'G';
	if(impulse <= 320)
		return 'H';
	if(impulse <= 640)
		return 'I';
	if(impulse <= 1280)
		return 'J';
	if(impulse <= 2560)
		return 'K';
	if(impulse <= 5120)
		return 'L';
	if(impulse <= 10240)
		return 'M';
	if(impulse <= 20480)
		return 'N';
	if(impulse <= 40960)
		return 'O';
	if(impulse <= 81920)
		return 'P';
	if(impulse <= 163840)
		return 'Q';
	if(impulse <= 32760)
		return 'R';
	if(impulse <= 665360)
		return 'S';
	
	return 'T+';
}